export default __webpack_public_path__ + "static/media/pelunasan-kasir.ac9a4de6.png";